import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { ArrowUpRight, Send } from "lucide-react";
import { NAV } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LEGAL = [
  { label: "Mentions légales", to: "/mentions-legales" },
  { label: "Confidentialité", to: "/confidentialite" },
  { label: "CGU", to: "/cgu" },
  { label: "CGV", to: "/cgv" },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return toast.error("Entrez un email valide.");
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("Inscription confirmée !", { description: "Merci, vous recevrez nos nouveautés." });
      setEmail("");
    } catch (e) {
      toast.error("Inscription impossible.", { description: "Veuillez réessayer." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="relative bg-ink-900 text-paper grain overflow-hidden" data-testid="footer">
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10 pt-24 pb-10">
        <div className="grid lg:grid-cols-[1.4fr_1fr_1fr] gap-14">
          <div>
            <span className="label-mono text-gold">Industrial Performance. Reinvented.</span>
            <h2 className="font-display text-4xl md:text-6xl font-semibold mt-5 leading-[0.95]">
              Prêt à transformer votre performance industrielle ?
            </h2>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="group inline-flex items-center gap-3 mt-8 rounded-full bg-gold text-ink px-7 py-4 label-mono hover:bg-paper transition-colors duration-300"
            >
              Demander un diagnostic
              <ArrowUpRight size={16} className="group-hover:rotate-45 transition-transform duration-300" />
            </Link>

            <div className="mt-12 max-w-md">
              <span className="label-mono text-steel">Newsletter</span>
              <p className="text-paper/70 text-sm mt-3">Recevez nos nouveaux outils, ressources et contenus sur la performance industrielle.</p>
              <form onSubmit={subscribe} className="flex gap-2 mt-4" data-testid="newsletter-form">
                <input
                  type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  data-testid="newsletter-email" placeholder="Votre email"
                  className="flex-1 bg-white/5 border hairline-light rounded-full px-5 py-3 text-sm outline-none focus:border-gold transition-colors placeholder:text-paper/40"
                />
                <button type="submit" disabled={loading} data-testid="newsletter-submit"
                  className="inline-flex items-center gap-2 rounded-full bg-paper text-ink px-5 label-mono hover:bg-gold transition-colors disabled:opacity-60">
                  {loading ? "…" : <>S'inscrire <Send size={13} /></>}
                </button>
              </form>
            </div>
          </div>

          <div>
            <span className="label-mono text-steel">Navigation</span>
            <ul className="mt-6 space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="link-underline text-paper/80 hover:text-gold transition-colors">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <span className="label-mono text-steel">Contact</span>
            <ul className="mt-6 space-y-3 text-paper/80">
              <li>Paris, France</li>
              <li><a href="mailto:novalean26@outlook.fr" className="link-underline hover:text-gold">novalean26@outlook.fr</a></li>
              <li><a href="tel:+33668751416" className="link-underline hover:text-gold">+33 6 68 75 14 16</a></li>
            </ul>
            <div className="flex gap-4 mt-6 label-mono">
              <a href="#" className="hover:text-gold transition-colors">LinkedIn</a>
              <a href="#" className="hover:text-gold transition-colors">YouTube</a>
              <a href="#" className="hover:text-gold transition-colors">X</a>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t hairline-light flex flex-col lg:flex-row justify-between gap-6 label-mono text-steel">
          <span className="font-display text-2xl font-bold text-paper tracking-tight">NOVA<span className="text-gold">LEAN</span></span>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {LEGAL.map((l) => (
              <Link key={l.to} to={l.to} className="hover:text-gold transition-colors">{l.label}</Link>
            ))}
          </div>
          <span>© {new Date().getFullYear()} Nova Lean Consulting. Tous droits réservés.</span>
        </div>
      </div>
    </footer>
  );
}
